import React from "react";
import PageContents from "../components/layouts/PageContents";
import UserPreferencesForm from "../components/projectusers/UserPreferencesForm";

const PreferencesPage: React.FC = () => {
    return (
        <PageContents
            title="Preferences"
            subtitle="Manage your preferences."
            isForbidden={false}
            variant="small"
        >
            <UserPreferencesForm />
        </PageContents>
    );
};

export default PreferencesPage;
